/**
 * @generated SignedSource<<d0ee746101d3dea52b887bd9122f2886>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GoalTypeKind = "GOAL" | "SUCCESS_MEASURE";
export type GoalTypeState = "DISABLED" | "ENABLED";
export type useGoalUniversalCreateItemsQuery$variables = {
  containerId: string;
  hasContainerId: boolean;
};
export type useGoalUniversalCreateItemsQuery$data = {
  readonly townsquare?: {
    readonly goalTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly ari: string;
          readonly kind: GoalTypeKind | null;
          readonly name: {
            readonly defaultValue?: string | null;
            readonly messageId?: string | null;
            readonly value?: string | null;
          } | null;
          readonly state: GoalTypeState | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type useGoalUniversalCreateItemsQuery = {
  response: useGoalUniversalCreateItemsQuery$data;
  variables: useGoalUniversalCreateItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasContainerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "includeDisabled",
    "value": true
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "ari"
},
v3 = {
  "kind": "ScalarField",
  "name": "kind"
},
v4 = {
  "kind": "ScalarField",
  "name": "state"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ],
  "type": "GoalTypeCustomName"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "LocalizationField"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGoalUniversalCreateItemsQuery",
    "selections": [
      {
        "condition": "hasContainerId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "Townsquare",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "GoalTypeConnection",
                "kind": "LinkedField",
                "name": "goalTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "name",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGoalUniversalCreateItemsQuery",
    "selections": [
      {
        "condition": "hasContainerId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "Townsquare",
            "kind": "LinkedField",
            "name": "townsquare",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "GoalTypeConnection",
                "kind": "LinkedField",
                "name": "goalTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GoalTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GoalType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "name",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v5/*: any*/),
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "fee28fbb85cc254cc1932c08cd074ff0",
    "id": null,
    "metadata": {},
    "name": "useGoalUniversalCreateItemsQuery",
    "operationKind": "query",
    "text": "query useGoalUniversalCreateItemsQuery(\n  $containerId: String!\n  $hasContainerId: Boolean!\n) {\n  townsquare @include(if: $hasContainerId) {\n    goalTypes(containerId: $containerId, first: 100, includeDisabled: true) {\n      edges {\n        node {\n          ari\n          kind\n          state\n          name {\n            __typename\n            ... on GoalTypeCustomName {\n              value\n            }\n            ... on LocalizationField {\n              messageId\n              defaultValue\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5253ee6edf8578c023cbb935021077c";

export default node;
